(function () {
  function initMeeoowHoverImages(root) {
    var scope = root || document;
    scope.querySelectorAll('img.meeoow-hover-image[data-hover-src]').forEach(function (img) {
      var wrap = img.closest('.hover');
      if (!wrap || img.dataset.hoverLoaded === 'true') {
        return;
      }

      function loadHoverImage() {
        if (img.dataset.hoverLoaded === 'true') {
          return;
        }
        img.src = img.getAttribute('data-hover-src');
        var hoverSrcset = img.getAttribute('data-hover-srcset');
        if (hoverSrcset) {
          img.srcset = hoverSrcset;
        }
        img.dataset.hoverLoaded = 'true';
      }

      wrap.addEventListener('mouseenter', loadHoverImage, { once: true });
      wrap.addEventListener('focusin', loadHoverImage, { once: true });
    });
  }

  function mountMeeoowTabPanel(block) {
    if (!block) {
      return;
    }

    var templateId = block.getAttribute('data-meeoow-tab-template');
    if (!templateId || block.dataset.meeoowMounted === 'true') {
      return;
    }

    var template = document.getElementById(templateId);
    if (!template || !template.content) {
      return;
    }

    block.appendChild(template.content.cloneNode(true));
    block.dataset.meeoowMounted = 'true';
    initMeeoowHoverImages(block);
  }

  window.MeeoowHome = {
    mountTabPanel: mountMeeoowTabPanel,
    initHoverImages: initMeeoowHoverImages
  };

  function boot() {
    initMeeoowHoverImages(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
